import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { createRoom, createStaff, createStaffRole, createStaffShift, deleteRoom, deleteStaffs, fetchAllStaff, fetchInactiveStaff, fetchPreStaffRole, fetchRooms, fetchShaffRoleDetails, fetchShiftById, fetchStaff, fetchStaffById, fetchStaffDetailsById, fetchStaffRole, fetchUnAssignStaff, staffkiosPinExist, toggleStaffStatus, updateStaff, updateStaffRole, updateStaffShift, updateStaffTimeStamp } from "../../../service/api";


export const getStaff = createAsyncThunk(
    "staff/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaff(params)
            console.log("staff", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getInactiveStaff = createAsyncThunk(
    "staff/inactive",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchInactiveStaff(params)
            console.log("staff", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const editStaffStatus = createAsyncThunk(
    "staff/status",
    async (params, { rejectWithValue }) => {
        try {
            const response = await toggleStaffStatus(params)
            console.log("staff", response)
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getStaffById = createAsyncThunk(
    "staff/ById",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffById(params)
            console.log("staff details", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getStaffDetailsById = createAsyncThunk(
    "staffDetails/ById",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffDetailsById(params)
            console.log("staff details vi id", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getShiftById = createAsyncThunk(
    "shift/ById",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchShiftById(params)

            console.log("params", params)
            console.log("shift", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getStaffRoleById = createAsyncThunk(
    "shiftRole/ById",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchShaffRoleDetails(params)
            console.log("params role details", params)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getAllStaff = createAsyncThunk(
    "staff/allStaff",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchAllStaff(params)
            console.log("staff all", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getUnrolleStaff = createAsyncThunk(
    "staff/unroleStaff",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchUnAssignStaff(params)
            console.log("assign staff", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)


export const getStaffRole = createAsyncThunk(
    "staff/staffRole",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchStaffRole(params)
            console.log("staff role", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const getPreStaffRole = createAsyncThunk(
    "staff/preRole",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchPreStaffRole(params)
            console.log("staff  pre role", response)
            return response.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

export const deleteStaff = createAsyncThunk(
    "staff/delete",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await deleteStaffs(formValue)
            if (response.status === 201) {
                console.log("delete", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)




export const addStaff = createAsyncThunk(
    "staff/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createStaff(formValue)
            if (response.status === 201) {
                console.log("response", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const validatekioskSignInPin = createAsyncThunk(
    "staff/validate",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await staffkiosPinExist(formValue)
            if (response.status === 200) {
                console.log("response", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const addStaffRole = createAsyncThunk(
    "staffRole/add",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createStaffRole(formValue)
            if (response.status === 201) {
                console.log("add staff role", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)


export const addStaffShift = createAsyncThunk(
    "staff/addShift",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await createStaffShift(formValue)
            if (response.status === 201) {
                console.log("response", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)
export const editStaff = createAsyncThunk(
    "staff/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateStaff(newData)
            if (response.status === 201) {
                console.log("edit staff", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)

export const editStaffShift = createAsyncThunk(
    "staffShift/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateStaffShift(newData)
            if (response.status === 201) {
                console.log("edit shift ", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)

export const editStaffRole = createAsyncThunk(
    "staffRole/edit",
    async (newData, { rejectWithValue }) => {
        try {
            const response = await updateStaffRole(newData)
            if (response.status === 201) {
                console.log("edit role ", response)
            }
        } catch (error) {
            console.log(error)
            return rejectWithValue(error.response.data || error.message)
        }
    }
)

export const editStaffTimeStamp = createAsyncThunk(
    "staff/timeStamp",
    async (params, { rejectWithValue }) => {
        try {
            const response = await updateStaffTimeStamp(params)
            console.log("staff time stamp", response)
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)
        }
    }
)

const staffSlice = createSlice({
    name: "staff",
    initialState: {
        staffsList: [],
        inactiveStaffList: [],
        allStaffsList: [],
        unRoleStaffsList: [],
        staffById: {},
        shiftById: {},
        staffRole: {},
        staffPreRole: {},
        staffRoleById: {},
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        inactiveTotalPage: 0,
        current: 1,
        limit: 10,
        searchParams: "",
        role: "",
        roomId: "",
        date:""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setRoleFilter: (state, action) => {
            state.role = action.payload;
        },
        setRoomFilter: (state, action) => {
            state.roomId = action.payload;
        },
         setDateFilter: (state, action) => {
            state.date = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(getStaff.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getStaff.fulfilled, (state, action) => {
                state.isLoading = false;
                state.staffsList = action.payload.data;
                state.totalPage = action.payload.totalPage
            })
            .addCase(getStaff.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })


            // INACTIVE
            .addCase(getInactiveStaff.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getInactiveStaff.fulfilled, (state, action) => {
                state.isLoading = false;
                state.inactiveStaffList = action.payload.data;
                state.inactiveTotalPage = action.payload.totalPage
            })
            .addCase(getInactiveStaff.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            //STATUS
            .addCase(editStaffStatus.pending, (state) => {
                state.actionLoader = true,
                    state.error = null
            })
            .addCase(editStaffStatus.fulfilled, (state, action) => {
                state.actionLoader = false;

            })
            .addCase(editStaffStatus.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload
            })

            //by id
            .addCase(getStaffById.pending, (state) => {
                state.error = null
            })
            .addCase(getStaffById.fulfilled, (state, action) => {
                state.staffById = action.payload.data;
            })
            .addCase(getStaffById.rejected, (state, action) => {
                state.error = action.payload
            })

            .addCase(getStaffDetailsById.pending, (state) => {
                state.error = null
            })
            .addCase(getStaffDetailsById.fulfilled, (state, action) => {
                state.staffById = action.payload.data;
            })
            .addCase(getStaffDetailsById.rejected, (state, action) => {
                state.error = action.payload
            })


            //shift by id
            .addCase(getShiftById.pending, (state) => {
                state.error = null
            })
            .addCase(getShiftById.fulfilled, (state, action) => {
                state.shiftById = action.payload.data;
            })
            .addCase(getShiftById.rejected, (state, action) => {
                state.error = action.payload
            })

            //staff role by id
            .addCase(getStaffRoleById.pending, (state) => {
                state.error = null
                state.isLoading = true
            })
            .addCase(getStaffRoleById.fulfilled, (state, action) => {
                state.staffRoleById = action.payload.data;
                state.isLoading = false

            })
            .addCase(getStaffRoleById.rejected, (state, action) => {
                state.error = action.payload
                state.isLoading = false

            })


            //all staff list
            .addCase(getAllStaff.pending, (state) => {
                state.error = null
            })
            .addCase(getAllStaff.fulfilled, (state, action) => {
                state.allStaffsList = action.payload.data;
            })
            .addCase(getAllStaff.rejected, (state, action) => {
                state.error = action.payload
            })

            //unrole staff list
            .addCase(getUnrolleStaff.pending, (state) => {
                state.error = null
            })
            .addCase(getUnrolleStaff.fulfilled, (state, action) => {
                state.unRoleStaffsList = action.payload.data;
            })
            .addCase(getUnrolleStaff.rejected, (state, action) => {
                state.error = action.payload
            })

            //all staff role
            .addCase(getStaffRole.pending, (state) => {
                state.error = null
            })
            .addCase(getStaffRole.fulfilled, (state, action) => {
                state.staffRole = action.payload.data;
            })
            .addCase(getStaffRole.rejected, (state, action) => {
                state.error = action.payload
            })

            // STAFF PRE ROLE

            .addCase(getPreStaffRole.pending, (state) => {
                // state.isLoading = true,
                    state.error = null
            })
            .addCase(getPreStaffRole.fulfilled, (state, action) => {
                // state.isLoading = false;
                state.staffPreRole = action.payload.data;
            })
            .addCase(getPreStaffRole.rejected, (state, action) => {
                // state.isLoading = false;
                state.error = action.payload
            })


            // POST
            .addCase(addStaff.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addStaff.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addStaff.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // VALIDATE 
            .addCase(validatekioskSignInPin.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(validatekioskSignInPin.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(validatekioskSignInPin.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // POST role
            .addCase(addStaffRole.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addStaffRole.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addStaffRole.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })


            // POST shift
            .addCase(addStaffShift.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(addStaffShift.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(addStaffShift.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editStaff.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editStaff.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editStaff.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT Role
            .addCase(editStaffRole.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editStaffRole.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editStaffRole.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT
            .addCase(editStaffShift.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editStaffShift.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editStaffShift.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // delete
            .addCase(deleteStaff.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(deleteStaff.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(deleteStaff.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })

            // PUT STAMP
            .addCase(editStaffTimeStamp.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(editStaffTimeStamp.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(editStaffTimeStamp.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams, setPagination, setRoleFilter, setRoomFilter ,setDateFilter} = staffSlice.actions;

export default staffSlice.reducer;